<template>
  <div :class="['btn', outOfLevel(type_data) && !type_data.received ? 'cantRecv' : '']" @click.stop="handleBtn(type_data)">
    {{ type_data.received >= 1 ? btnText : outOfLevel(type_data) ? '升级权益' : '立即抢' }}
  </div>
</template>
<script>
import click_handler from '../../../tools/mgtv/click';
import { outOfLevel } from './benefitApi';
import { GET_GIFT } from '../../../constant/eventbus';
import { getAwardRecv, getYuyueInfo } from '../../../api';
// 产品文档 https://wiki.imgo.tv/pages/viewpage.action?pageId=48204157

export default {
  name: 'BenefitButton',
  components: {},
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      }
    },
    type_data: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data: function() {
    return {
      btnText: ''
    };
  },
  created() {},
  methods: {
    outOfLevel,
    setBtnText(info) {
        if (info.award_type === 62) {
          // Mcity奖品判断是否填写地址
          if(this.user.ticket){
            getAwardRecv(this.info.act_name, info.award_id).then(res => {
              if (res && res.data && res.data.already_get) {
                this.btnText = '去兑换';
              } else {
                this.btnText = '立即领取';
              }
            });
          }
        } else {
          this.btnText = '已领取';
        }
    },
    handleBtn(awardInfo) {
      if (awardInfo.out_stock === 1) {
        return;
      }
      const need_vip_level = awardInfo.received === 1 ? 0 : awardInfo.growth_level; //如果已领取，则不检查等级，否则检查等级
      click_handler(
        `领取福利-${awardInfo.award_name}`,
        () => {
          if (this.outOfLevel(awardInfo) && !awardInfo.received) {
            window.$act_alert_dialog.show({
              title: `<div style="text-align: center;font-size:.36rem;color:#666;margin-bottom:.2rem">抱歉，领取失败～</div>
                    <div style="text-align: center;font-size:.28rem;color:#666;margin-bottom:.2rem">需满足会员身份未过期及符合对应等级才可领取哦~</div>`,
              button: '我知道了'
            });
            return;
          }
          window.$bus.$emit(GET_GIFT, {
            awardInfo: awardInfo,
            act_name: this.info.act_name,
            callback: this.setBtnText
          });
        },
        {
          need_login: true,
          need_act: true,
          need_vip_level: need_vip_level,
          need_mpp_svip: awardInfo.vip_id_limit === 'mpp_svip',
          max_vip_level: awardInfo.max_growth_level
        }
      );
    }
  },
  mounted() {
    this.setBtnText(this.type_data);
  },
  computed: {
    user() {
      return window.$bus.user;
    }
  }
};
</script>

<style lang="stylus" scoped>
@import "../../../share/mixins.styl"
.btn
  text-align: center
  width: 1.56rem;
  height: 0.56rem;
  background: linear-gradient(90deg, #FFE6B4 0%, #F6C371 100%);
  border-radius: 0.16rem;
  line-height: 0.56rem
  color: #804919;
  font-size: 0.24rem
  position: absolute
  top: 50%
  transform: translateY(-50%)
  right: 0.24rem
  overflow hidden
  &.cantRecv
    background:#FF5F00;
    color: #fff;
  img
    width: 100%
</style>
